/* eslint-disable @typescript-eslint/no-explicit-any */
import { EditOutlined } from '@ant-design/icons'
import { IPayloadAddTumByActionEvent } from 'app/api/event/model'
import { ITradeUnionMember } from 'app/api/tradeUnionMembers/model'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { InputNumber } from 'app/components/common/inputs/InputNumber'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { BaseDatePicker } from 'app/components/common/pickers/BaseDatePicker'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import { convertColumnTable } from 'app/components/tables/BaseTableReport/hook'
import { useUpdateTumInActionEvent } from 'app/react-query/hook/event'
import dayjs from 'dayjs'
import { useEffect, useMemo, useRef, useState } from 'react'
import styled from 'styled-components'
import { ModalSelectTum } from './ModalSelectTum'
import { IActivityEvent, IDataTumActivity, TypeColumn } from './type'
import { notificationController } from 'app/controllers/notification-controller'

export const UpdateTumInActionEvent = ({
  actionEvent,
  teamId,
}: {
  actionEvent?: IActivityEvent
  teamId?: number
}) => {
  const modalRef = useRef<IRefModal>(null)
  const [tums, setTums] = useState<IDataTumActivity[]>([])

  const [tumsOld, setTumsOld] = useState<IDataTumActivity[]>([])
  const [tumsAdd, setTumsAdd] = useState<IDataTumActivity[]>([])
  const [tumsUpdate, setTumsUpdate] = useState<IDataTumActivity[]>([])
  const [deletedIds, setDeletedIds] = useState<number[]>([])

  const { mutateAsync, isLoading } = useUpdateTumInActionEvent()

  const handleSubmit = async () => {
    const payload = {
      activity_id: actionEvent?.id,
      tums:
        tums?.map(member => ({
          id: member?.id,
          is_checked_in: member?.checkedIn,
          list_key_map_check_in: actionEvent?.locations?.map(
            lo => lo?.key_map_check_in,
          ),
          columns: actionEvent?.columns?.map(col => {
            const key = col?.keyOfMainData ?? col?.name ?? ''
            const valueExist = member?.[key]
            return {
              name: key,
              value: valueExist,
            }
          }),
        })) ?? [],
      teamId,
      tumsAdd:
        tumsAdd?.map(member => ({
          id: member?.id,
          is_checked_in: member?.checkedIn,
          list_key_map_check_in: actionEvent?.locations?.map(
            lo => lo?.key_map_check_in,
          ),
          columns: actionEvent?.columns?.map(col => {
            const key = col?.keyOfMainData ?? col?.name ?? ''
            const valueExist = member?.[key]
            return {
              name: key,
              value: valueExist,
            }
          }),
        })) ?? [],
      tumsUpdate:
        tumsUpdate?.map(member => ({
          id: member?.id,
          is_checked_in: member?.checkedIn,
          list_key_map_check_in: actionEvent?.locations?.map(
            lo => lo?.key_map_check_in,
          ),
          columns: actionEvent?.columns?.map(col => {
            const key = col?.keyOfMainData ?? col?.name ?? ''
            const valueExist = member?.[key]
            return {
              name: key,
              value: valueExist,
            }
          }),
          tumActivityId: member?.tumActivityId,
        })) ?? [],
      tumsDeleteIds: deletedIds,
    } as IPayloadAddTumByActionEvent

    const res = await mutateAsync?.(payload)

    if (res) {
      modalRef?.current?.hide?.()
      notificationController.success({ message: 'Cập nhật thành công' })
      window.location.reload()
    }
  }

  useEffect(() => {
    let tumsData: IDataTumActivity[] = []
    if (teamId) {
      const teamSelect = actionEvent?.teams?.find(team => team?.id === teamId)
      tumsData = teamSelect?.tums ?? []
    } else {
      tumsData = actionEvent?.data ?? []
    }
    setTums(
      tumsData?.map((e, idx) => ({
        ...e,
        key: idx + 1,
      })),
    )
    setTumsOld(tumsData)
  }, [actionEvent, teamId])

  const columns = useMemo(() => {
    return actionEvent?.columns?.filter(itm => !itm?.keyOfMainData) ?? []
  }, [actionEvent?.columns])

  const onChangeDataTum = (indexColumn: number, name: string, value: any) => {
    // tums
    const newData = [...(tums ?? [])]
    const updatedRow = { ...newData[indexColumn], [name]: value }
    newData[indexColumn] = updatedRow
    setTums(newData)

    // add
    const existingInAdd = tumsAdd.find(t => t.id === newData[indexColumn]?.id)
    if (existingInAdd) {
      setTumsAdd(prev => {
        return prev.map(t => (t.id === updatedId ? { ...t, [name]: value } : t))
      })
    }

    // update
    const updatedId = updatedRow?.id
    const existedInOld = tumsOld.some(t => t.id === updatedId)
    if (!updatedId || !existedInOld) return

    setTumsUpdate(prev => {
      const existing = prev.find(t => t.id === updatedId)
      if (existing) {
        return prev.map(t => (t.id === updatedId ? { ...t, [name]: value } : t))
      } else {
        return [...prev, updatedRow]
      }
    })
  }

  const onChangeTum = (newTums: IDataTumActivity[]) => {
    const oldMap = new Map(tumsOld.map(t => [t.id, t]))
    const newMap = new Map(newTums.map(t => [t.id, t]))

    const newAdd: IDataTumActivity[] = []
    const deleted: number[] = []

    // Kiểm tra những item bị xóa (có trong tumsOld nhưng không còn trong newTums)
    for (const old of tumsOld) {
      if (old.id && !newMap.has(old.id)) {
        deleted.push(+old?.id)
      }
    }

    // Kiểm tra những item mới thêm vào (không tồn tại trong tumsOld)
    for (const item of newTums) {
      if (!item.id || !oldMap.has(item.id)) {
        newAdd.push(item)
      }
    }

    setTums(newTums)
    setTumsAdd(newAdd)
    setDeletedIds(deleted)
  }

  return (
    <BaseModalComponent
      titleModal={'Cập nhật danh sách'}
      ref={modalRef}
      handleSubmit={handleSubmit}
      widthModal={1250}
      isShowLineBottom={false}
      isLoadingConfirm={isLoading}
      buttonOpenModal={
        <BaseButton
          icon={<EditOutlined rev={undefined} />}
          onClick={() => modalRef?.current?.open?.()}
        >
          {'Cập nhật'}
        </BaseButton>
      }
      renderContent={
        <BaseSpace>
          <BaseRow gutter={16} align={'middle'} justify={'space-between'}>
            <BaseCol>
              <BaseText children={'Danh sách đoàn viên'} />
            </BaseCol>
            <BaseCol>
              <ModalSelectTum data={tums} onSubmit={onChangeTum} />
            </BaseCol>
          </BaseRow>
          <BaseTableManagement
            columns={[
              convertColumnTable<ITradeUnionMember>({
                key: 'fullName',
                title: 'Tên đoàn viên',
                render: (_: any, record?: ITradeUnionMember) => {
                  return (
                    <BaseText
                      children={record?.fullName ?? ''}
                      fontWeight="medium"
                      opacity={'1'}
                    />
                  )
                },
              }),
              convertColumnTable<ITradeUnionMember>({
                key: 'mql',
                title: 'Mã quản lý',
                render: (_: any, record?: ITradeUnionMember) => {
                  return (
                    <BaseText
                      children={record?.mql ?? ''}
                      fontWeight="medium"
                      opacity={'1'}
                    />
                  )
                },
              }),
              convertColumnTable<ITradeUnionMember>({
                key: 'gioiTinh',
                title: 'Giới tính',
                render: (_: any, record?: ITradeUnionMember) => {
                  return (
                    <BaseText
                      children={record?.gioiTinh ?? ''}
                      fontWeight="medium"
                      opacity={'1'}
                    />
                  )
                },
              }),
              ...((columns?.map(column => {
                return {
                  title: column?.name,
                  dataIndex: column?.name,
                  key: column?.name,
                  className: 'big-column',
                  render: (_: any, record: any, indexRecord: number) => {
                    switch (column?.type) {
                      case TypeColumn.STRING: {
                        return (
                          <BaseFormItem hiddenLabel>
                            <BaseInput
                              value={record?.[column?.name ?? '']}
                              placeholder={column?.name}
                              onChange={e =>
                                onChangeDataTum(
                                  indexRecord,
                                  column?.name ?? '',
                                  e?.target?.value,
                                )
                              }
                            />
                          </BaseFormItem>
                        )
                      }
                      case TypeColumn.NUMBER: {
                        return (
                          <BaseFormItem hiddenLabel>
                            <BaseInputNumberWrapper
                              value={record?.[column?.name ?? '']}
                              placeholder={column?.name}
                              onChange={value =>
                                onChangeDataTum(
                                  indexRecord,
                                  column?.name ?? '',
                                  value,
                                )
                              }
                            />
                          </BaseFormItem>
                        )
                      }
                      case TypeColumn.DATE: {
                        return (
                          <BaseFormItem hiddenLabel>
                            <DatePickerWrapper
                              value={
                                record?.[column?.name ?? '']
                                  ? dayjs(record?.[column?.name ?? ''])
                                  : undefined
                              }
                              placeholder={column?.name}
                              onChange={value =>
                                onChangeDataTum(
                                  indexRecord,
                                  column?.name ?? '',
                                  value,
                                )
                              }
                            />
                          </BaseFormItem>
                        )
                      }

                      case TypeColumn.OTHER: {
                        return (
                          <BaseFormItem hiddenLabel>
                            <BaseInput
                              value={record?.[column?.name ?? '']}
                              placeholder={column?.name}
                            />
                          </BaseFormItem>
                        )
                      }
                    }
                  },
                }
              }) ?? []) as any),
            ]}
            dataSource={tums}
            className="row-overwrite-style"
            scroll={{ x: true, y: tums?.length ? 400 : undefined }}
          />
        </BaseSpace>
      }
    />
  )
}

const BaseFormItem = styled(BaseForm.Item)`
  margin-bottom: 0px;
`

const BaseInputNumberWrapper = styled(InputNumber)`
  width: 100%;
`

const DatePickerWrapper = styled(BaseDatePicker)`
  width: 100%;
`
